<template>
  <div class="app-container">
    <CrudTable entity="ReturnReasonCategory" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'name', label: 'return.returnReasonCategory' },
        { field: 'categoryNumber', label: 'return.returnReasonCategoryCode' }
      ]
    };
  }
};
</script>

<style scoped></style>
